import { render, staticRenderFns } from "./NkrCodeLink.vue?vue&type=template&id=e12a3c86&scoped=true"
import script from "./NkrCodeLink.vue?vue&type=script&lang=js"
export * from "./NkrCodeLink.vue?vue&type=script&lang=js"
import style0 from "./NkrCodeLink.vue?vue&type=style&index=0&id=e12a3c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12a3c86",
  null
  
)

export default component.exports